export const ASSISTANT_ENDPOINT = '/c/v1/chat/assistant/init';
